<section class="rounded-3xl bg-white p-2 shadow-sm dark:bg-slate-900 lg:p-4">
  <div class="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h3 class="text-lg sm:text-[1rem] font-semibold text-slate-900 dark:text-white">
        {{ title }}
      </h3>
      @if (subtitle) {
        <p class="mt-2 max-w-3xl text-sm text-slate-500 dark:text-slate-300">
          {{ subtitle }}
        </p>
      }
    </div>
  </div>

  <div class="mt-4 hidden overflow-x-auto lg:block">
    <table class="min-w-full text-left text-sm">
      <thead>
        <tr class="border-b border-slate-200 text-slate-500 dark:border-slate-700 dark:text-slate-300">
          <th class="px-3 py-2 font-semibold">Método</th>
          <th class="px-3 py-2 font-semibold text-center">Esperado</th>
          <th class="px-3 py-2 font-semibold text-center">Contado</th>
          <th class="px-3 py-2 font-semibold text-center">Diferencia</th>
          <th class="px-3 py-2 font-semibold text-center">Ventas</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.bucket) {
          <tr class="border-b border-slate-100 dark:border-slate-800">
            <td class="px-3 py-3">
              <div class="flex items-center gap-3">
                @if (showIcons) {
                  <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-200">
                    <i [class]="getMethodIconClass(row.bucket)"></i>
                  </span>
                }
                <div class="flex min-h-9 items-center">
                  <p class="font-medium text-slate-900 dark:text-white">
                    {{ row.label }}
                  </p>
                </div>
              </div>
            </td>

            <td class="px-3 py-3 text-center font-medium text-slate-900 dark:text-white">
              {{ formatCurrency(row.expected_amount) }}
            </td>

            <td class="px-3 py-3 text-center">
              @if (editableCounted) {
                @if (getCountedControl(row.bucket); as countedControl) {
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    [formControl]="countedControl"
                    placeholder="0.00"
                    (focus)="handleCountedFocus(countedControl)"
                    (blur)="handleCountedBlur(countedControl)"
                    class="h-11 w-20 rounded-xl border border-slate-300 bg-white px-3 text-center text-sm font-semibold text-slate-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-100 dark:border-slate-600 dark:bg-slate-950 dark:text-white dark:focus:ring-primary-900/40"
                    [class.border-rose-400]="countedControl.invalid && countedControl.touched"
                  />
                } @else {
                  <span class="font-medium text-slate-400 dark:text-slate-500">
                    N/D
                  </span>
                }
              } @else {
                <span class="font-medium text-slate-900 dark:text-white">
                  {{
                    row.counted_amount === null
                      ? 'Pendiente'
                      : formatCurrency(row.counted_amount)
                  }}
                </span>
              }
            </td>

            <td class="px-3 py-3 text-center">
              <div class="flex flex-col items-center">
                <span
                  class="font-semibold"
                  [class]="getDifferenceClass(row.difference_amount)"
                >
                  {{
                    row.difference_amount === null
                      ? 'Pendiente'
                      : formatCurrency(row.difference_amount)
                  }}
                </span>
                @if (showDifferenceLabel && row.difference_amount !== null) {
                  <span class="text-xs" [class]="getDifferenceClass(row.difference_amount)">
                    {{ getDifferenceLabel(row.difference_amount) }}
                  </span>
                }
              </div>
            </td>

            <td class="px-3 py-3 text-center font-medium text-slate-900 dark:text-white">
              {{ row.sales_count }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="mt-4 grid gap-3 lg:hidden">
    @for (row of rows; track row.bucket) {
      <article class="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-700 dark:bg-slate-800/60">
        <div class="flex items-start justify-between gap-3">
          <div class="flex items-center gap-3">
            @if (showIcons) {
              <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-slate-600 shadow-sm dark:bg-slate-900 dark:text-slate-200">
                <i [class]="getMethodIconClass(row.bucket)"></i>
              </span>
            }
            <div>
              <p class="font-semibold text-slate-900 dark:text-white">
                {{ row.label }}
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                {{ row.sales_count }} ventas
              </p>
            </div>
          </div>
        </div>

        <div class="mt-4 grid grid-cols-2 gap-3">
          <div>
            <p class="text-sm font-semibold text-slate-600 dark:text-slate-300">
              Esperado
            </p>
            <p class="mt-1 text-base font-semibold text-slate-900 dark:text-white">
              {{ formatCurrency(row.expected_amount) }}
            </p>
          </div>

          <div>
            <p class="text-sm font-semibold text-slate-600 dark:text-slate-300">
              Contado
            </p>
            @if (editableCounted) {
              @if (getCountedControl(row.bucket); as countedControl) {
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  [formControl]="countedControl"
                  placeholder="0.00"
                  (focus)="handleCountedFocus(countedControl)"
                  (blur)="handleCountedBlur(countedControl)"
                  class="mt-1 h-11 w-full rounded-xl border border-slate-300 bg-white px-3 text-right text-sm font-semibold text-slate-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-100 dark:border-slate-600 dark:bg-slate-950 dark:text-white dark:focus:ring-primary-900/40"
                  [class.border-rose-400]="countedControl.invalid && countedControl.touched"
                />
              } @else {
                <p class="mt-1 text-base font-semibold text-slate-400 dark:text-slate-500">
                  N/D
                </p>
              }
            } @else {
              <p class="mt-1 text-base font-semibold text-slate-900 dark:text-white">
                {{
                  row.counted_amount === null
                    ? 'Pendiente'
                    : formatCurrency(row.counted_amount)
                }}
              </p>
            }
          </div>

          <div class="col-span-2 rounded-xl bg-white px-3 py-3 dark:bg-slate-900">
            <div class="flex items-center justify-between gap-3">
              <div>
                <p class="text-sm font-semibold text-slate-600 dark:text-slate-300">
                  Diferencia
                </p>
                <p
                  class="mt-1 text-base font-semibold"
                  [class]="getDifferenceClass(row.difference_amount)"
                >
                  {{
                    row.difference_amount === null
                      ? 'Pendiente'
                      : formatCurrency(row.difference_amount)
                  }}
                </p>
              </div>
              @if (showDifferenceLabel && row.difference_amount !== null) {
                <span
                  class="rounded-full px-3 py-1 text-xs font-semibold"
                  [class]="getDifferenceClass(row.difference_amount)"
                >
                  {{ getDifferenceLabel(row.difference_amount) }}
                </span>
              }
            </div>
          </div>
        </div>
      </article>
    }
  </div>
</section>
